<div class="" style="max-width: 1000px" *ngIf="plan.Gateways.length > 0">
  <div class="bold medium">{{ 'ADMIN_LTI.TABS.GATEWAYS' | translate }}</div>
  <div class="hint background2">
    <i class="fa fa-info-circle"></i>
    &nbsp;{{ 'PARTECIPANT_LTI.OBJECTIVES.GATEWAYS_HINT' | translate }}
  </div>
  <table class="table">
    <thead>
      <tr>
        <th class="name background2"></th>
        <th class="background2">
          {{ 'ADMIN_LTI.GATEWAYS.BODY.CONSULTATION_TYPE' | translate }}
        </th>
        <th class="background2">
          {{ 'PARTECIPANT_LTI.OBJECTIVES.COLUMNS.MEASURE' | translate }}
        </th>
        <th class="background2">
          {{ 'PARTECIPANT_LTI.OBJECTIVES.COLUMNS.THRESHOLD' | translate }}
        </th>
        <!--<th class="background2">{{'PARTECIPANT_LTI.OBJECTIVES.COLUMNS.WEIGHT' | translate}}</th>-->
        <th class="background2">
          {{ 'PARTECIPANT_LTI.OBJECTIVES.COLUMNS.BONUS_SENSIVITY' | translate }}
        </th>
        <th class="background2" *ngFor="let year of getYears()">{{ year }}</th>
        <th class="background2" *ngIf="hasDetail('Gateways')"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let item of plan.Gateways">
        <tr>
          <td class="background2 name">{{ item.Goal.Name }}</td>
          <td class="background2">{{ item.ConsultationType }}</td>
          <td class="background2">{{ getMeasure(item) }}</td>
          <td class="background2">{{ getObjectTargetThreshold(item) }}</td>
          <!--<td class="background2">{{item.Weight}}%</td>-->
          <td class="background2">{{ getObjectSensivity(item) }}</td>
          <td *ngFor="let year of getYears()" class="giallo">
            {{ getObjectiveValue(item, year) }}
          </td>
          <th class="background2" *ngIf="item.Name">
            <i
              class="fa fa-caret-down pointer"
              [ngClass]="{
                'fa-caret-down': !item.showDetail,
                'fa-caret-up': item.showDetail
              }"
              (click)="item.showDetail = !item.showDetail"
            ></i>
          </th>
        </tr>
        <tr *ngIf="item.showDetail && item.Name">
          <td [attr.colspan]="getYears().length + 6">{{ item.Name }}</td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
<div class="" *ngIf="plan.Objectives.length > 0">&nbsp;</div>
<div class="" style="max-width: 1000px" *ngIf="plan.Objectives.length > 0">
  <div class="bold medium">{{ 'ADMIN_LTI.TABS.OBJECTIVES' | translate }}</div>
  <div class="hint background2">
    <i class="fa fa-info-circle"></i>
    &nbsp;{{ 'PARTECIPANT_LTI.OBJECTIVES.OBJECTIVES_HINT' | translate }}
  </div>
  <table class="table">
    <thead>
      <tr>
        <th class="name background2"></th>
        <th class="background2">
          {{ 'ADMIN_LTI.GATEWAYS.BODY.CONSULTATION_TYPE' | translate }}
        </th>
        <th class="background2">
          {{ 'PARTECIPANT_LTI.OBJECTIVES.COLUMNS.MEASURE' | translate }}
        </th>
        <th class="background2">
          {{ 'PARTECIPANT_LTI.OBJECTIVES.COLUMNS.THRESHOLD' | translate }}
        </th>
        <!--<th class="background2">{{'PARTECIPANT_LTI.OBJECTIVES.COLUMNS.WEIGHT' | translate}}</th>-->
        <th class="background2">
          {{ 'PARTECIPANT_LTI.OBJECTIVES.COLUMNS.BONUS_SENSIVITY' | translate }}
        </th>
        <th class="background2" *ngFor="let year of getYears()">{{ year }}</th>
        <th class="background2" *ngIf="hasDetail('Objectives')"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let item of plan.Objectives">
        <tr>
          <td class="background2 name">{{ item.Goal.Name }}</td>
          <td class="background2">{{ item.ConsultationType }}</td>
          <td class="background2">{{ getMeasure(item) }}</td>
          <td class="background2">{{ getObjectTargetThreshold(item) }}</td>
          <!--<td class="background2">{{item.Weight}}%</td>-->
          <td class="background2">{{ getObjectSensivity(item) }}</td>
          <td *ngFor="let year of getYears()" class="giallo">
            {{ getObjectiveValue(item, year) }}
          </td>
          <th class="background2" *ngIf="item.Name">
            <i
              class="fa fa-caret-down pointer"
              [ngClass]="{
                'fa-caret-down': !item.showDetail,
                'fa-caret-up': item.showDetail
              }"
              (click)="item.showDetail = !item.showDetail"
            ></i>
          </th>
        </tr>
        <tr *ngIf="item.showDetail && item.Name">
          <td [attr.colspan]="getYears().length + 6">{{ item.Name }}</td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
<div class="" *ngIf="plan.Correctives.length > 0">&nbsp;</div>
<div class="" style="max-width: 1000px" *ngIf="plan.Correctives.length > 0">
  <div class="bold medium">{{ 'ADMIN_LTI.TABS.CORRECTIVE' | translate }}</div>
  <div class="hint background2">
    <i class="fa fa-info-circle"></i>
    &nbsp;{{ 'PARTECIPANT_LTI.OBJECTIVES.CORRECTIVE_HINT' | translate }}
  </div>
  <table class="table">
    <thead>
      <tr>
        <th class="name background2"></th>
        <th class="background2">
          {{ 'ADMIN_LTI.GATEWAYS.BODY.CONSULTATION_TYPE' | translate }}
        </th>
        <th class="background2">
          {{ 'PARTECIPANT_LTI.OBJECTIVES.COLUMNS.MEASURE' | translate }}
        </th>
        <th class="background2">
          {{ 'PARTECIPANT_LTI.OBJECTIVES.COLUMNS.THRESHOLD' | translate }}
        </th>
        <!--<th class="background2">{{'PARTECIPANT_LTI.OBJECTIVES.COLUMNS.WEIGHT' | translate}}</th>-->
        <th class="background2">
          {{ 'PARTECIPANT_LTI.OBJECTIVES.COLUMNS.BONUS_SENSIVITY' | translate }}
        </th>
        <th class="background2" *ngFor="let year of getYears()">{{ year }}</th>
        <th class="background2" *ngIf="hasDetail('Correctives')"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let item of plan.Correctives">
        <tr>
          <td class="background2 name">{{ item.Goal.Name }}</td>
          <td class="background2">{{ item.ConsultationType }}</td>
          <td class="background2">{{ getMeasure(item) }}</td>
          <td class="background2">{{ getObjectTargetThreshold(item) }}</td>
          <!--<td class="background2">{{item.Weight}}%</td>-->
          <td class="background2">{{ getObjectSensivity(item) }}</td>
          <td *ngFor="let year of getYears()" class="giallo">
            {{ getObjectiveValue(item, year) }}
          </td>
          <th class="background2" *ngIf="item.Name">
            <i
              class="fa fa-caret-down pointer"
              [ngClass]="{
                'fa-caret-down': !item.showDetail,
                'fa-caret-up': item.showDetail
              }"
              (click)="item.showDetail = !item.showDetail"
            ></i>
          </th>
        </tr>
        <tr *ngIf="item.showDetail && item.Name">
          <td [attr.colspan]="getYears().length + 6">{{ item.Name }}</td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
